import * as React from "react";
const services = [{
  title: "CONSULTING",
  description: "Wolfram's consultancy service contributes to a substantial part of our business with assistance and goodwill provided from the many years of experience and knowledge of the mining industry."
}, {
  title: "SERVICE & MAINTENANCE",
  description: "Our comprehensive service and maintenance programs are designed to keep your critical equipment operating at peak performance, reducing unexpected breakdowns and ensuring continuous productivity."
}, {
  title: "TECHNICIANS",
  description: "We provide highly trained and experienced technicians to support your on-site operations, ensuring all maintenance and repair tasks are executed safely, efficiently, and to the highest industry standards."
}];
export default function ServicesShowcase() {
  return <section id="services-showcase" className="bg-background py-16 md:py-24">
      <div className="page-container">
        <div className="mx-auto flex max-w-4xl flex-col gap-16 text-center md:gap-20">
          {services.map((service, i) => <div key={i} data-index={i} className="flex flex-col gap-4 md:gap-6">
              <h3 className="font-default text-2xl font-bold tracking-wider uppercase text-chart-4 md:text-3xl">
                {service.title}
              </h3>
              <p className="mx-auto max-w-3xl text-base leading-relaxed text-muted-foreground md:text-lg">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}